<template>
  <div class="caseClip_Course" :style="{ minHeight: `${height}`,}">
      <a-row class="data-count">
        <a-col :span="6" >
          <div style="padding-right: 20px">
            <a-card :bordered="false" style="height: 130px">
              <div class="data-count-day">
                <div>
                  <span>今日病程导出数量</span>
                </div>
                <div class="data-count-day-sum">
                  <h1 style="font-size: xx-large">{{ ExportNum.today }}</h1>
                  <div>
                    <span>昨日</span>&nbsp;&nbsp;&nbsp;<span style="color: black">{{ ExportNum.yesterday }}</span>
                  </div>
                </div>
                <a-divider />
                <div class="data-count-day-sum">
                  <span>本月导出总数量&nbsp;&nbsp;&nbsp;<span style="color: black">{{ ExportNum.thisMonth }}</span></span>
                </div>
              </div>
            </a-card>
          </div>
        </a-col>
        <a-col :span="6" >
          <div style="padding-right: 20px">
            <a-card :bordered="false" style="height: 130px">
              <div class="data-count-day">
                <div>
                  <span>病程导出使用人数</span>
                </div>
                <div class="data-count-day-sum">
                  <h1 style="font-size: xx-large">{{ ExportUserNum.today }}</h1>
                  <div>
                    <span>昨日</span>&nbsp;&nbsp;&nbsp;<span style="color: black">{{ ExportUserNum.yesterday }}</span>
                  </div>
                </div>
                <a-divider />
                <div class="data-count-day-sum">
                  <span>本月访问总人数&nbsp;&nbsp;&nbsp;<span style="color: black">{{ ExportUserNum.thisMonth }}</span></span>
                </div>
              </div>
            </a-card>
          </div>
        </a-col>
        <a-col :span="6" >
          <div style="padding-right: 20px">
            <a-card :bordered="false" style="height: 130px">
              <div class="data-count-day">
                <div>
                  <span>今日病程单次导出使用次数</span>
                </div>
                <div class="data-count-day-sum">
                  <h1 style="font-size: xx-large">{{ ExportWordNum.today }}</h1>
                  <div>
                    <span>昨日</span>&nbsp;&nbsp;&nbsp;<span style="color: black">{{ ExportWordNum.yesterday }}</span>
                  </div>
                </div>
                <a-divider />
                <div class="data-count-day-sum">
                  <span>本月使用总人数&nbsp;&nbsp;&nbsp;<span style="color: black">{{ ExportWordNum.thisMonth }}</span></span>
                </div>
              </div>
            </a-card>
          </div>
        </a-col>
        <a-col :span="6">
          <a-card :bordered="false" style="height: 130px;">
            <div class="data-count-day">
              <div>
                <span>今日病程批量导出使用次数</span>
              </div>
              <div class="data-count-day-sum">
                <h1 style="font-size: xx-large">{{ ExportExcelNum.today }}</h1>
                <div>
                  <span>昨日</span>&nbsp;&nbsp;&nbsp;<span style="color: black">{{ ExportExcelNum.yesterday }}</span>
                </div>
              </div>
              <a-divider />
              <div class="data-count-day-sum">
                <span>本月使用总人数&nbsp;&nbsp;&nbsp;<span style="color: black">{{ ExportExcelNum.thisMonth }}</span></span>
              </div>
            </div>
          </a-card>
        </a-col>
      </a-row>
    <div class="date-day">
      <div class="box-header">
        <h3>病程导出（日）</h3>
        <a-range-picker v-model="day" @change="day_picker" :disabled-date="disabledDate" />
      </div>
      <div class="box-line" id="dayLine">

      </div>

    </div>
    <div class="date-day">
      <div class="box-header">
        <h3>病程导出（月）</h3>
        <div>
          <a-month-picker v-model="month[0]"
                          valueFormat="YYYY-MM"
                          :disabled-date="disabledDate"
                          placeholder="开始月份"
                          @change="month_picker()"

          />
          ~
          <a-month-picker v-model="month[1]"
                          valueFormat="YYYY-MM"
                          :disabled-date="disabledDate"
                          placeholder="结束月份"
                          @change="month_picker()"

          />
        </div>
      </div>
      <div class="box-line" id="monthLine">

      </div>

    </div>
  </div>
</template>

<script>
import moment from "moment";
import * as echarts from 'echarts';
import {getCaseExportList,caseExportNum,caseExportExcelNum,caseExportWordNum,caseExportUserNum} from "@/service/caseClip_api";
export default {
  name: "caseClip_Course",
  data(){
    const disabledDate = current => {
      return current && current > moment().endOf('day')
    };
    const disabledMonth = current => {
      return current && current > moment().endOf('month')
    };
    return{
      height:window.innerHeight-64-30 + "px",
      day:[moment().subtract(3,'month').format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')],
      month:[moment().subtract(6,'month').format('YYYY-MM'),moment().format('YYYY-MM')],
      disabledDate,
      disabledMonth,
      dayData: {
        userNum:[],
        wordNum:[],
        excelNum:[]
      },
      monthData: {
        userNum:[],
        wordNum:[],
        excelNum:[]
      },
      ExportNum:{},
      ExportUserNum:{},
      ExportWordNum:{},
      ExportExcelNum:{},
    }
  },
   mounted() {
    this.get_caseExportNum()
    this.get_caseExportUserNum()
    this.get_caseExportWordNum()
    this.get_caseExportExcelNum()
    this.getCaseData('days',this.day[0],this.day[1])
    this.getCaseData('months',this.month[0],this.month[1])
  },
  methods:{
    async get_caseExportNum(){
      const info = await caseExportNum()
      if (info.code===0){
        this.ExportNum=info.data
      }
    },
    async get_caseExportUserNum(){
      const info = await caseExportUserNum()
      if (info.code===0){
        this.ExportUserNum=info.data
      }
    },
    async get_caseExportWordNum(){
      const info = await caseExportWordNum()
      if (info.code===0){
        this.ExportWordNum=info.data
      }
    },
    async get_caseExportExcelNum(){
      const info = await caseExportExcelNum()
      if (info.code===0){
        this.ExportExcelNum=info.data
      }
  },


    async getCaseData(type,startTime,endTime){
      const data={
        type:type,
        startTime:startTime,
        endTime:endTime,
      }
      const info=await getCaseExportList(data)
      if (info.code===0){
        switch (type){
          case 'days':
            this.dayData={
              userNum:[],
              wordNum:[],
              excelNum:[]
            }
            info.data.forEach((value,index)=>{
              this.dayData.userNum.push({
                time:value.days,
                sum:value.userNum,
              })
              this.dayData.wordNum.push({
                time:value.days,
                sum:value.wordNum,
              })
              this.dayData.excelNum.push({
                time:value.days,
                sum:value.excelNum,
              })
            })
            this.line_day()
            break;
          case 'months':
            this.monthData={
              userNum:[],
              wordNum:[],
              excelNum:[]
            }
            info.data.forEach((value,index)=>{
              this.monthData.userNum.push({
                time:value.months,
                sum:value.userNum,
              })
              this.monthData.wordNum.push({
                time:value.months,
                sum:value.wordNum,
              })
              this.monthData.excelNum.push({
                time:value.months,
                sum:value.excelNum,
              })
            })
            this.line_month()
            break;
        }

      }
    },
    day_picker(date, dateString){
      this.day=dateString
      this.getCaseData('days',this.day[0],this.day[1])
    },
    month_picker(date, dateString,type){
      console.log(this.month)
      if (this.month[1]<this.month[0]){
        this.$message.error('结束日期不能大于开始日期')
      }else {
        this.getCaseData('months',this.month[0],this.month[1])
      }
    },

    line_day(){
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.getElementById('dayLine'));
      // 绘制图表
      myChart.setOption({
        legend: {
          data: ['病程导出使用人数', '病程单次导出使用次数', '病程批量导出使用次数']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        tooltip: {},
        dataset: [
          {
            source: this.dayData.userNum
          },
          {
            source: this.dayData.wordNum
          },
          {
            source: this.dayData.excelNum
          }
        ],
        xAxis: {
          type: 'category',
        },
        yAxis: {
          type: 'value',
        },
        series:[
          {
            datasetIndex:0,
            name:'病程导出使用人数',
            type:'line',
            smooth: true,
          },
          {
            datasetIndex:1,
            name:'病程单次导出使用次数',
            type:'line',
            smooth: true,
          },
          {
            datasetIndex:2,
            name:'病程批量导出使用次数',
            type:'line',
            smooth: true,
          },
        ]
      });
    },
    line_month(){
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.getElementById('monthLine'));
      // 绘制图表
      myChart.setOption({
        legend: {
          data: ['病程导出使用人数', '病程单次导出使用次数', '病程批量导出使用次数']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        tooltip: {},
        dataset: [
          {
            source: this.monthData.userNum
          },
          {
            source: this.monthData.wordNum
          },
          {
            source: this.monthData.excelNum
          }
        ],
        xAxis: {
          type: 'category',
        },
        yAxis: {
          type: 'value',
        },
        series:[
          {
            datasetIndex:0,
            name:'病程导出使用人数',
            type:'line',
            smooth: true,
          },
          {
            datasetIndex:1,
            name:'病程单次导出使用次数',
            type:'line',
            smooth: true,
          },
          {
            datasetIndex:2,
            name:'病程批量导出使用次数',
            type:'line',
            smooth: true,
          },
        ]
      });
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .ant-divider{
  margin:0 0 10px 0;
}
h1,h2,h3{
  margin:0;
}
.caseClip_Course{
  margin: -15px;
  background-color: #f0f2f5;
  height: auto;
  .data-count{

    h1{
      margin:0;
    }
    span{
      color: rgba(0, 0, 0, 0.427450980392157);
    }
    display: flex;
    justify-content: space-between;
    .data-count-day{
      .data-count-day-sum{
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
  .date-day{
    margin-top: 20px;
    background: white;
    min-height: 500px;
    .box-header{
      align-items: center;
      padding: 10px 20px;
      width: 100%;
      height: 50px;
      border-bottom: 1px solid #e8e8e8;
      display: flex;
      justify-content: space-between;
    }
    .box-line{
      padding: 10px 20px;
      width: 98%;
      min-height: 400px;
      height: auto;
    }
  }
}
</style>